import styles from "./chat.module.css";
import MachineGPT from "../machineGPT/index.jsx";

import GinaAlert from "./gina_content_holder";
import React, { useEffect, useState } from "react";
import Spinner from "react-bootstrap/Spinner";
import { useLocation } from "react-router-dom";
import ChatAssistant from "../../pages/ai/ChatAssistant.jsx";
import { SafeHtml } from "../SafeHtml/index.jsx";

function GinaTemplateCmms({ children, action, loading, maximize }) {
  const location = useLocation();
  const [wording, setWording] = useState("");
  const [checked, setChecked] = useState(false);
  const [ginaActive, setGinaActive] = useState(false);
  const [lastMessage, setLastMessage] = useState(null);
  const [showLastMessage, setShowLastMessage] = useState(true);

  useEffect(() => {
    setGinaActive(maximize);
  }, [maximize]);

  function toggleCallOut() {
    setGinaActive(!ginaActive);
    setChecked(false);
  }

  const handleMessageUpdate = (message) => {
    setLastMessage(message);
    setShowLastMessage(true);
  };

  const hideLastMessage = () => {
    setShowLastMessage(false);
  };

  useEffect(() => {
    // setGinaActive(false);
  }, [location]);
  // useEffect(() => {
  //   const getCallout = localStorage.getItem("gina_callout");
  //   if (callout && getCallout === "1") {
  //     setWording(callout);
  //     setChecked(true);
  //   } else {
  //     setWording("");
  //     setChecked(false);
  //   }
  // }, [callout]);
  return (
    <>
      <div className={styles.ginaPlaceholder}>
        {!ginaActive && (
          <div className={styles.ginaContainer}>
            {/* {lastMessage &&
              showLastMessage &&
              lastMessage.role === "assistant" && (
                <div className={styles.lastMessage}>
                  <button
                    className={styles.hideMessageBtn}
                    onClick={hideLastMessage}
                    title="Hide message"
                  >
                    <i className="fas fa-times"></i>
                  </button>

                  <div className={styles.messagePreview}>
                    <SafeHtml
                      text={
                        lastMessage.content.text ||
                        lastMessage.content.reply ||
                        "..."
                      }
                    />
                  </div>
                </div>
              )}
            {lastMessage && !showLastMessage && (
              <button
                className={styles.showMessageBtn}
                onClick={() => setShowLastMessage(true)}
                title="Show last message"
              >
                <i className="fas fa-comment"></i>
              </button>
            )} */}

            <img
              onClick={toggleCallOut}
              className={styles.gina}
              src="/img/ai_face_big.png"
              alt="GINA AI"
            />
          </div>
        )}

        <div className={ginaActive ? styles.ginaCallout : styles.hiddenGina}>
          <div>
            <img
              onClick={toggleCallOut}
              className={`${styles.ginaActive} ${styles.gina}`}
              src="/img/ai_face_big.png"
              alt="GINA AI"
            />
          </div>
          {ginaActive && (
            <div
              style={{
                marginLeft: "80px",
                fontWeight: "bold",
                marginTop: "-8px",
              }}
            >
              <div style={{ color: "#d3d3d3" }}>GINA</div>
              <div style={{ color: "#ababab", fontSize: "14px" }}>
                AI Assistant
              </div>
            </div>
          )}

          <div className={styles.minimize} onClick={toggleCallOut}>
            minimize
          </div>
          <div
            className="white-text"
            style={{
              marginTop: "-10px",
              padding: "10px",
            }}
          >
            <div className="alert-text">
              <GinaAlert minimize={toggleCallOut} url={action}>
                <ChatAssistant
                  open={ginaActive}
                  onMessageUpdate={handleMessageUpdate}
                />
              </GinaAlert>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default GinaTemplateCmms;
